import SpaceBetween from '@cloudscape-design/components/space-between'
import { AgentStatusSection } from './AgentStatusSection'
import { ExceptionQueueSection } from './ExceptionQueueSection'
import { RecentDecisionsSection } from './RecentDecisionsSection'
import { RunHistorySection } from './RunHistorySection'
import { useAgentStatus } from '@/hooks/useAgentStatus'

interface Props {
  clientId: string
}

export function ClientAgentPage({ clientId }: Props) {
  const { goal, persona, nextAutoRunAt, lastAutoRunAt, loading } = useAgentStatus(clientId)
  return (
    <SpaceBetween size="l">
      <AgentStatusSection clientId={clientId} goal={goal} persona={persona} nextAutoRunAt={nextAutoRunAt} lastAutoRunAt={lastAutoRunAt} loading={loading} />
      <RunHistorySection clientId={clientId} />
      <ExceptionQueueSection clientId={clientId} />
      <RecentDecisionsSection clientId={clientId} />
    </SpaceBetween>
  )
}
